import Purchase from '../Purchase';

class PurchasedItem extends Purchase {
    constructor(store, data) {
        super(store, data);
        this.isDigital = false;
        this.track = this.data.delivery.tracking !== '' ? this.data.delivery.tracking : null;
        this.items = this.data.items;
        this.items.forEach((item) => {
            item.url = `/goods/${item.item.url}`;
        });
        this.price = this.items.reduce((acc, item) => {
            return acc + item.item.price * item.quantity;
        }, 0)
    }

    updateFromJson(json) {
    }

    get status() {
        const { status, system, extendDeliveryStatus } = this.data.delivery;
        if ( system === '_2' || system === '_1' ) {
            if ( status === 'A_0' ) {
                return 'В ожидании вас в офисе'
            }
            if ( status === 'A_2' ) {
                return 'Выдано'
            }
            return 'Не определено'
        }
        if ( system === 'A_1' || system === 'A_2' ) {
            if ( status === 'A_0' ) {
                return 'Готовится к отправке'
            }
            if (status === 'A_1') {
                if (extendDeliveryStatus) {
                    return extendDeliveryStatus
                }
                return 'В пути'
            }
            if (status === 'A_2') {
                return 'Доставлено'
            }
            return 'Не определено'
        }
        return 'Не определено'
    }
}

export default PurchasedItem
